import { Typography, Grid, Stack } from '@mui/material';
import { PromoCard } from '../../promo-card';
import { NavItemChildDesktop } from '../nav-item-child';
import { DropdownItem, CardEvent } from 'types/header';

export const CardEventLayout = ({
  dropdownItems,
  cardEvent,
  closeDropdown,
}: {
  dropdownItems: DropdownItem[];
  cardEvent: CardEvent;
  closeDropdown: () => void;
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item lg={6}>
        <Stack direction={'row'} gap={3}>
          {dropdownItems.map((item, index) => (
            <Stack
              key={item.title}
              gap={1}
              height={312}
              overflow={'hidden'}
              width={'100%'}
              pr={3}
              borderRight={theme =>
                index < dropdownItems.length - 1
                  ? `1px solid ${theme.palette.grey[400]}`
                  : undefined
              }
            >
              <Typography variant="body1" color={'grey.600'}>
                {item.title}
              </Typography>
              <NavItemChildDesktop item={item} closeDropdown={closeDropdown} />
            </Stack>
          ))}
        </Stack>
      </Grid>
      <Grid item lg={6}>
        <PromoCard cardEvent={cardEvent} />
      </Grid>
    </Grid>
  );
};
